import { useLazyQuery } from '@apollo/client';
import { GET_QUIZ_ATTEMPT } from '../../apollo/queries/quiz';

const useQuizAttempt = () => {
  const [fetchAttempt, { data, loading, error }] = useLazyQuery(GET_QUIZ_ATTEMPT);

  return {
    fetchAttempt,
    attempt: data?.getQuizAttempt,
    loading,
    error,
  };
};

export default useQuizAttempt;